// extracted by mini-css-extract-plugin
export default {"main":"SearchBar_main__xBBGs","magnifying_glass":"SearchBar_magnifying_glass__kRFVC","img":"SearchBar_img__Px5qk","input":"SearchBar_input__FwggK"};